"use strict";

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Styled = void 0;

var _styledComponents = require("styled-components");

var _utils = require("../../../utils");

var _getIndentations = require("../../../utils/get-indentations");

var _grid = require("./grid.inject");

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n          ", ";\n\n          margin-left: auto;\n          margin-right: auto;\n        "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    display: grid;\n    width: 100%;\n\n    ", ";\n\n    ", ";\n\n    ", "\n    ", "\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n\n    ", ";\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Cell = (0, _utils.sc)('div')(function (_ref) {
  var index = _ref.index,
      cellsSizes = _ref.cellsSizes,
      gridBreakpoints = _ref.gridBreakpoints,
      breakpoints = _ref.breakpoints,
      offsets = _ref.offsets;
  return (0, _styledComponents.css)(_templateObject(), _grid.inject.cellTemplate({
    cellsSizes: cellsSizes,
    index: index,
    gridBreakpoints: gridBreakpoints,
    breakpoints: breakpoints,
    offsets: offsets
  }));
})('Cell');
var Grid = (0, _utils.sc)('div')(function (_ref2) {
  var divisions = _ref2.divisions,
      isContainer = _ref2.isContainer,
      cellsCount = _ref2.cellsCount,
      breakpoints = _ref2.breakpoints,
      $margin = _ref2.$margin,
      $padding = _ref2.$padding;
  return (0, _styledComponents.css)(_templateObject2(), _grid.inject.gridBreakpointTemplate({
    divisions: divisions,
    isContainer: isContainer,
    cellsCount: cellsCount,
    breakpoints: breakpoints
  }), isContainer ? (0, _styledComponents.css)(_templateObject3(), _grid.inject.gridContainerStyles({
    breakpoints: breakpoints
  })) : '', (0, _getIndentations.getIndentations)({
    type: 'margin',
    indentObj: $margin
  }), (0, _getIndentations.getIndentations)({
    type: 'padding',
    indentObj: $padding
  }));
})('Grid');
var Styled = {
  Cell: Cell,
  Grid: Grid
};
exports.Styled = Styled;